import { loadTheme } from '../loadTheme'

const themeColor = '#d5001c'
const textColor = '#313639'

export const emosLightTheme = loadTheme({
  themeColor,
  textColor,
})
